import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import noop from 'lodash/noop';

import styles from './Link.module.scss';

export default function Link(props) {
  const {
    href,
    children,
    className,
    target,
    gwtPlace,
    gwtId,
    callback,
    title,
    ...otherProps
  } = props;

  const dataTestId = otherProps['data-testid'] || 'link';

  function handleClick(e) {
    e.preventDefault();
    callback();

    if (window.XM_goToGwtPlace) {
      window.XM_goToGwtPlace(gwtPlace, gwtId);
    } else {
      window.XM_goToXMPlace(gwtPlace, gwtId);
    }
  }

  const onClick = gwtPlace ? handleClick : undefined;

  return (
    <a
      onClick={onClick}
      href={href}
      className={classnames(styles.link, className)}
      target={target}
      title={title}
      data-testid={dataTestId}
      {...otherProps}
    >
      {children}
    </a>
  );
}

Link.propTypes = {
  /**
   * URL target of Link.
   */
  href: PropTypes.string,
  /**
   * Visible content of Link.
   */
  children: PropTypes.node,
  /**
   * Name of CSS class to apply to content.
   */
  className: PropTypes.string,
  /**
   * Window target that Link will open up in Name of CSS class to apply to content.
   */
  target: PropTypes.string,
  /**
   * Google Web Toolkit Place string to navigate to.
   */
  gwtPlace: PropTypes.string,
  /**
   * Id string to pass as parameter to Google Web Toolkit Place.
   */
  gwtId: PropTypes.string,
  /**
   * Callback to execute before the onClick
   */
  callback: PropTypes.func,
  title: PropTypes.string,
};

Link.defaultProps = {
  href: '',
  children: undefined,
  className: '',
  target: '',
  gwtPlace: '',
  gwtId: '',
  callback: noop,
  title: '',
};

Link.displayName = 'Link';
